module.exports = __webpack_public_path__ + "static/img/welcome.ad82ec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome.svg
// module id = LAkS
// module chunks = 1